import React from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import { TextField } from "../../UI/TextField";
import { useRightPopupContext } from "./context";

export const SearchInput = () => {
  const { search, setSearch } = useRightPopupContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value);

  return (
    <TextField value={search} placeholder="Search" elemAfterInput={<SearchRoundedIcon />} onChange={handleChange} />
  );
};
